<template>
  <el-dialog
    :append-to-body="true"
    :title="title"
    :visible.sync="dialogForm.visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="40%"
    @open="openDialog"
    v-dialogDrag
  >
    <el-form label-width="100px" :model="form" :rules="rules" ref="form">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="申请部门" prop="applyDepartment">
            <el-input
              v-model="form.applyDepartment"
              clearable
              size="small"
              placeholder="请输入"
              :disabled="title === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请应用" prop="applyApplicationName">
            <el-input
              v-model="form.applyApplicationName"
              clearable
              size="small"
              placeholder="请输入"
              :disabled="title === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请人" prop="applyUserId">
            <el-select
              v-model="form.applyUserId"
              filterable
              clearable
              size="small"
              placeholder="请选择申请人"
              @change="changeApplyUserId"
              class="!w-full"
              :disabled="title === '查看'"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="form.applicationApart"
              clearable
              size="small"
              placeholder="请输入"
              :disabled="title === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row v-if="title !== '查看'">
      <el-input
        v-model="keyword"
        clearable
        size="small"
        placeholder="请输入名称/代码"
        class="w-200px mr-10px"
      ></el-input>
      <el-button type="primary" @click="searchClassData">搜索</el-button>
      <el-button type="primary" @click="handleAdd">添加</el-button>
      <el-button type="danger" @click="deleteData">删除</el-button>
    </el-row>
    <div v-if="title === '查看'" class="text-16px">订阅清单</div>
    <el-table
      class="mt-20px"
      border
      :data="tableData"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      height="300px"
      ref="tableData"
    >
      <el-table-column type="selection" width="55" v-if="title !== '查看'"></el-table-column>
      <el-table-column label="序号" type="index" width="55"></el-table-column>
      <el-table-column label="订阅代码" prop="code" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.subscribePublishCode ? scope.row.subscribePublishCode : scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订阅名称" prop="name" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.subscribePublishName ? scope.row.subscribePublishName : scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订阅地址" prop="address" show-overflow-tooltip> </el-table-column>
      <el-table-column :label="$t('操作')" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="copyAddress(scope.row)">复制地址</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="h-48px" v-if="title !== '查看'">
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="page.pageNo"
        :page-size="page.pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <div slot="footer" class="dialog-footer tc" v-if="title !== '查看'">
      <el-button type="primary" @click="save">{{ $t('save') }}</el-button>
      <el-button @click="dialogForm.visible = false">{{ $t('cancel') }}</el-button>
    </div>

    <!-- 添加订阅 -->
    <el-dialog
      :append-to-body="true"
      title="添加订阅"
      :visible.sync="showAdd"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      width="40%"
      v-dialogDrag
    >
      <el-row>
        <el-input
          v-model="query.keyword"
          clearable
          size="small"
          placeholder="请输入名称/代码"
          class="w-200px mr-10px"
        ></el-input>
        <el-button type="primary" @click="getClassData">搜索</el-button>
      </el-row>
      <el-table
        class="mt-20px"
        border
        :data="classData"
        :highlight-current-row="true"
        @selection-change="handleSelectionClass"
        height="300px"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="55"></el-table-column>
        <el-table-column label="订阅代码" prop="code" width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="订阅名称" prop="name" width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="订阅地址" prop="address"> </el-table-column>
      </el-table>
      <div class="h-48px">
        <el-pagination
          class="mt-20px float-right"
          background
          @current-change="handleCurrentClass"
          @size-change="handleSizeClass"
          :current-page.sync="classPage.pageNo"
          :page-size="classPage.pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next, jumper"
          :total="classPage.total"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer tc" v-if="title !== '查看'">
        <el-button type="primary" @click="addClass">{{ $t('save') }}</el-button>
        <el-button @click="showAdd = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import SubscribePublishService from '@/services/SubscribePublishService'
import SubscriptionApplicationService from '@/services/SubscriptionApplicationService'

export default {
  props: ['dialogForm'],
  data() {
    return {
      form: {
        applyDepartment: '',
        applyApplicationName: '',
        applyUserId: '',
        applyUserName: '',
      },
      rules: {
        applyDepartment: [{ required: true, message: '请输入申请部门', trigger: 'blur' }],
        applyApplicationName: [{ required: true, message: '请输入申请应用', trigger: 'blur' }],
        applyUserId: [{ required: true, message: '请选择申请人', trigger: 'change' }],
      },
      keyword: '',
      tableData: [],
      selectionList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      showAdd: false,
      query: {
        keyword: '',
      },
      classData: [],
      classSelection: [],
      classPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      userList: [],
      title: '',
    }
  },
  methods: {
    async openDialog() {
      await this.getUser()
      this.queryForm = this.$options.data().queryForm
      if (this.dialogForm.type === 'add') {
        this.title = '新增'
        this.form = this.$options.data().form
        this.tableData = []
        this.dialogForm.id = null
      } else if (this.dialogForm.type === 'update') {
        this.title = '编辑'
      } else {
        this.title = '查看'
      }
      this.getDetail()
      this.searchTableData()
    },
    handleSelectionChange(val) {
      this.selectionList = val
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    searchClassData() {
      if (this.dialogForm.type === 'add') {
        this.$message.warning('请先保存')
        return
      }
      this.searchTableData()
    },
    async searchTableData() {
      if (!this.dialogForm.id) return
      const res = await SubscriptionApplicationService.getApplyDetailPagedResult({
        id: this.dialogForm.id,
        detailId: this.dialogForm.detailId,
        filter: this.keyword,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = { ...this.form }
          const classIds = this.tableData.map((item) => {
            return item.id || item.classId
          })
          params.subscribePublishIds = classIds
          if (this.dialogForm.id) {
            // 修改
            this.updateSubscribeApply(params)
          } else {
            // 新增
            this.addSubscribeApply(params)
          }
        }
      })
    },
    // 新增订阅申请
    async addSubscribeApply(params) {
      const res = await SubscriptionApplicationService.addSubscribeApply(params)
      if (res && res.code === 0) {
        this.$message.success('新增成功')
        this.dialogForm.visible = false
        this.$emit('refresh')
      }
    },
    // 编辑订阅申请
    async updateSubscribeApply(params) {
      const res = await SubscriptionApplicationService.updateSubscribeApply(
        this.dialogForm.id,
        params
      )
      if (res && res.code === 0) {
        this.$message.success('修改成功')
        this.dialogForm.visible = false
        this.$emit('refresh')
      }
    },
    handleSelectionClass(val) {
      this.classSelection = val
    },
    handleCurrentClass(num) {
      this.classPage.pageNo = num
    },
    handleSizeClass(size) {
      this.classPage.pageSize = size
    },
    addClass() {
      if (this.classSelection.length === 0) {
        this.$message.info('请选择你要添加的数据')
        return
      }
      const arr = []
      const flagArr = []
      this.tableData.forEach((item) => {
        arr.push(item.id)
      })
      this.classSelection.forEach((val) => {
        const check = val.id
        if (_.includes(arr, check)) {
          flagArr.push(false)
        } else {
          flagArr.push(true)
        }
      })
      // 从新勾选的项和这边表格已选项是否有重叠的
      if (_.every(flagArr, Boolean)) {
        this.tableData = this.classSelection.concat(this.tableData)
        this.showAdd = false
      } else {
        this.$message.warning('该数据已添加')
      }
    },
    /**
     * @function 获取用户
     */
    async getUser() {
      const fileServer = Wiz.GetModuleServer('system-management')
      const res = await axios.get(
        `${fileServer}/api/eaf-user-role/get-users?SkipCount=0&MaxResultCount=999`
      )
      if (res && res.data && res.status === 200) {
        this.userList = res.data.items
      }
    },
    async getClassData() {
      const res = await SubscribePublishService.geDataList({
        StandardId: '',
        Filter: this.query.keyword,
        Sorting: '',
        SkipCount: (this.classPage.pageNo - 1) * this.classPage.pageSize,
        MaxResultCount: this.classPage.pageSize,
      })
      if (res && res.code === 0) {
        this.classData = res.data
        this.classPage.total = res.totalCount
      }
    },
    // 添加
    handleAdd() {
      this.showAdd = true
      this.getClassData()
    },
    deleteData() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.tableData = this.tableData.filter((item) => {
        return !this.selectionList.includes(item)
      })
      this.page.total = this.tableData.length
      this.selectionList = []
      this.$refs.tableData.clearSelection()
    },
    changeApplyUserId(val) {
      if (val) {
        _.map(this.userList, (item) => {
          if (val === item.id) {
            this.form.applyUserName = item.name
          }
        })
      }
    },
    // 获取详情
    async getDetail() {
      if (!this.dialogForm.id) return
      const res = await SubscriptionApplicationService.readSubscribeApply(this.dialogForm.id)
      if (res && res.code === 0) {
        this.form = res.data
      }
    },
    copyAddress(row) {
      const textarea = document.createElement('textarea')
      textarea.value = row.address
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.info('已经成功复制到剪贴板！')
    },
  },
}
</script>
